<script setup lang="ts">

import { usePQAStore } from '@/stores/PQAStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import Backend from '@/models/backend.ts'
import { computed, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const pqaStore = usePQAStore()
const gameStore = useGameStore()

const playerConquerPQA = ref(0)

const pqaOptions = computed(() =>
  [...pqaStore.queues.values()].map((pqa) => ({ value: pqa.id, label: pqa.name }))
)

const selectAndSubmit = (val: string | number) => {
  playerConquerPQA.value = Number(val)
  setPQA()
}

const setPQA = () => {
  const backend = new Backend()
  backend.setPlayerConquerPQA(playerConquerPQA.value).then(() => {
    gameStore.modalType=''
  })
}

onMounted(() => {
  playerConquerPQA.value = gameStore.player?.conquerPQA ?? 0
})


</script>

<template>
  <div class="">
    <div class="pb-2 text-metal-300">{{ t('government.cabinet.autoAssign.conquerQueue') }}</div>
    <div>
      <FormSelect
        :modelValue="playerConquerPQA"
        @update:modelValue="selectAndSubmit"
        :options="pqaOptions"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
</style>